module.exports = __webpack_public_path__ + "static/media/pref.966465cc.svg";